var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2840_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83 0.78H8.36V0H7.58V0.78H2.42V0H1.64V0.78H1.17C0.525 0.78 0 1.305 0 1.955V8.83C0 9.475 0.525 10 1.17 10H8.825C9.47 10 9.995 9.475 9.995 8.83V1.955C9.995 1.31 9.47 0.785 8.825 0.785L8.83 0.78ZM9.22 8.83C9.22 9.045 9.045 9.22 8.83 9.22H1.17C0.955 9.22 0.78 9.045 0.78 8.83V3.67H9.22V8.825V8.83ZM9.22 2.89H0.78V1.95C0.78 1.735 0.955 1.56 1.17 1.56H1.64V2.34H2.42V1.56H7.575V2.34H8.355V1.56H8.825C9.04 1.56 9.215 1.735 9.215 1.95V2.89H9.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26486 4.48999H1.48486V5.26999H2.26486V4.48999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82492 4.48999H3.04492V5.26999H3.82492V4.48999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38986 4.48999H4.60986V5.26999H5.38986V4.48999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94992 4.48999H6.16992V5.26999H6.94992V4.48999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51486 4.48999H7.73486V5.26999H8.51486V4.48999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26486 6.05505H1.48486V6.83505H2.26486V6.05505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82492 6.05505H3.04492V6.83505H3.82492V6.05505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38986 6.05505H4.60986V6.83505H5.38986V6.05505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94992 6.05505H6.16992V6.83505H6.94992V6.05505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26486 7.61499H1.48486V8.39499H2.26486V7.61499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82492 7.61499H3.04492V8.39499H3.82492V7.61499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38986 7.61499H4.60986V8.39499H5.38986V7.61499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94992 7.61499H6.16992V8.39499H6.94992V7.61499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51486 6.05505H7.73486V6.83505H8.51486V6.05505Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2840_740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.291d84bbc2fcb5244f19e5f96469092c.svg";
export { ForwardRef as ReactComponent };